var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "zkContent",
    {
      attrs: { leftStyle: "width:40%", rightStyle: "width:60%" },
      on: { contentHeight: _vm.setcontentHeight }
    },
    [
      _c(
        "div",
        { attrs: { slot: "left" }, slot: "left" },
        [_c("zk-role-group", { on: { menuSelect: _vm.menuSelect } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "right" }, slot: "right" },
        [_c("zk-role-user", { attrs: { selectRoleId: _vm.selectRoleId } })],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bebe013", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bebe013","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/roleLayout/src/main.vue
// module id = null
// module chunks = 